module.exports = __webpack_public_path__ + "images/speed-four-default.40ab4e0dcaea408c2b2598368ce7963d.png";